<template>
    <div>
        <v-card>
            <v-card-title
                class="font-weight-bold darkgrey--text"
                style="word-break: break-word !important"
            >
                {{
                    $attrs.detail.sub_interpretation_id || $attrs.detail.cta_id
                        ? "Ubah"
                        : "Tambah"
                }}

                Sub Interpretasi

                <v-spacer />
                <v-btn text color="red" @click="confirmDeleteItem()">
                    <v-icon small class="mr-2">mdi-delete</v-icon>
                    Hapus
                </v-btn>
            </v-card-title>
            <v-card-text class="py-5">
                <v-list-item two-line class="pa-0">
                    <v-list-item-content class="pa-0">
                        <v-list-item-title
                            style="font-size: 14px"
                            class="font-weight-500 black60--text pb-2"
                        >
                            Jenis Sub Interpretasi
                        </v-list-item-title>

                        <div>
                            <v-radio-group
                                row
                                v-model="content_type"
                                style="margin-top: -5px"
                                :disabled="
                                    $attrs.detail.sub_interpretation_id ||
                                    $attrs.detail.cta_id
                                "
                            >
                                <v-radio
                                    label="Text"
                                    value="text"
                                    class="radio-selection"
                                    active-class="act-radio-btn"
                                ></v-radio>
                                <v-radio
                                    label="CTA"
                                    value="cta"
                                    class="radio-selection"
                                    active-class="act-radio-btn"
                                ></v-radio>
                            </v-radio-group>
                        </div>
                    </v-list-item-content>
                </v-list-item>

                <template v-if="content_type === 'text'">
                    <v-list-item two-line class="pa-0">
                        <v-list-item-content class="pa-0">
                            <v-list-item-title
                                style="font-size: 14px"
                                class="font-weight-500 black60--text pb-2"
                            >
                                Judul
                            </v-list-item-title>
                            <v-text-field
                                placeholder="Judul"
                                v-model="data.title"
                                outlined
                            />
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item two-line class="pa-0">
                        <v-list-item-content>
                            <v-row style="align-items: center">
                                <v-col cols="4" class="d-flex justify-center">
                                    <a href="javascript:;">
                                        <img
                                            :src="
                                                url
                                                    ? url
                                                    : data.image &&
                                                        data.image != ''
                                                      ? data.image
                                                      : require('@/assets/img/unavailable.png')
                                            "
                                            :key="keyimg"
                                        />
                                    </a>
                                </v-col>

                                <v-col cols="6">
                                    <v-btn
                                        @click="$refs.uploader.click()"
                                        depressed
                                        class="font-weight-bold blew--text"
                                    >
                                        Upload Foto
                                    </v-btn>

                                    <input
                                        id="photo_tema_skala"
                                        type="file"
                                        ref="uploader"
                                        class="d-none"
                                        accept="image/*"
                                        @change="onFileChange"
                                    />

                                    <div
                                        class="mt-3 grey--text"
                                        style="font-size: 13px"
                                    >
                                        Rasio thumbnail Icon 1:1 (HD)
                                    </div>
                                </v-col>
                            </v-row>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item two-line class="pa-0">
                        <v-list-item-content class="pa-0">
                            <v-list-item-title
                                style="font-size: 14px"
                                class="font-weight-500 black60--text"
                            >
                                Deskripsi
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-card-text class="pa-0" style="margin-top: -10px">
                        <app-editor
                            v-on:content-updated="data.description = $event"
                            :value="data.description"
                            :hasUpload="false"
                            :title="'Deskripsi'"
                        ></app-editor>
                    </v-card-text>
                </template>

                <template v-else>
                    <v-list-item two-line class="pa-0">
                        <v-list-item-content class="pa-0">
                            <v-list-item-title
                                style="font-size: 14px"
                                class="font-weight-500 black60--text pb-2"
                            >
                                Jenis CTA
                            </v-list-item-title>
                            <div>
                                <v-radio-group
                                    row
                                    v-model="data_cta.cta_name"
                                    style="margin-top: -5px"
                                    :disabled="$attrs.detail.cta_id"
                                    @change="data_cta.cta_contents = []"
                                >
                                    <v-radio
                                        label="Career Mapping"
                                        value="prodi"
                                        class="radio-selection"
                                        active-class="act-radio-btn"
                                    ></v-radio>

                                    <v-radio
                                        label="Konsul"
                                        value="konsul"
                                        class="radio-selection"
                                        active-class="act-radio-btn"
                                    ></v-radio>

                                    <v-radio
                                        label="Fitur"
                                        value="fitur"
                                        class="radio-selection"
                                        active-class="act-radio-btn"
                                    ></v-radio>
                                </v-radio-group>
                            </div>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item
                        v-if="data_cta.cta_name === 'konsul'"
                        two-line
                        class="pa-0"
                    >
                        <v-list-item-content class="pa-0">
                            <v-list-item-title
                                style="font-size: 14px"
                                class="font-weight-500 black60--text pb-2"
                            >
                                Mata Pelajaran Konsul
                            </v-list-item-title>
                            <v-select
                                v-model="mapel_konsul"
                                class="pa-0"
                                :items="mapelList"
                                outlined
                                item-text="nama"
                                item-value="id"
                                placeholder="Pilih Mata Pelajaran"
                            >
                                <!-- <template v-slot:selection="{ item }">
                  <v-list-item v-if="mapel_konsul !== null" class="pa-0 ma-0">
                    <v-list-item-avatar class="py-0 my-0">
                      <img :src="item.picture" />
                    </v-list-item-avatar>
                    <v-list-item-title class="py-0 my-0">{{
                      item.nama
                    }}</v-list-item-title>
                  </v-list-item>
                </template> -->
                                <template v-slot:item="{ item }">
                                    <div
                                        class="d-flex py-3"
                                        style="
                                            align-items: center;
                                            gap: 15px;
                                            width: 100%;
                                        "
                                        @click="addCTAContent(item, 'konsul')"
                                    >
                                        <div>
                                            <img
                                                :src="item.picture"
                                                width="40"
                                                height="40"
                                            />
                                        </div>
                                        <div style="font-size: 15px">
                                            {{ item.nama }}
                                        </div>
                                    </div>
                                </template>
                            </v-select>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item
                        v-if="data_cta.cta_name === 'fitur'"
                        two-line
                        class="pa-0"
                    >
                        <v-list-item-content class="pa-0">
                            <v-list-item-title
                                style="font-size: 14px"
                                class="font-weight-500 black60--text pb-2"
                            >
                                Fitur
                            </v-list-item-title>
                            <v-select
                                v-model="feature"
                                class="pa-0"
                                :items="featureList"
                                outlined
                                item-text="nama"
                                item-value="id"
                                placeholder="Pilih Fitur"
                            >
                                <!-- <template v-slot:selection="{ item }">
                  <v-list-item class="pa-0 ma-0">
                    <v-list-item-avatar class="py-0 my-0">
                      <img :src="item.picture" />
                    </v-list-item-avatar>
                    <v-list-item-title class="py-0 my-0">{{
                      item.nama
                    }}</v-list-item-title>
                  </v-list-item>
                </template> -->
                                <template v-slot:item="{ item }">
                                    <div
                                        class="d-flex py-3"
                                        style="
                                            align-items: center;
                                            gap: 15px;
                                            width: 100%;
                                        "
                                        @click="addCTAContent(item, 'fitur')"
                                    >
                                        <div>
                                            <img
                                                :src="item.picture"
                                                width="39"
                                                height="39"
                                            />
                                        </div>
                                        <div style="font-size: 15px">
                                            {{ item.nama }}
                                        </div>
                                    </div>
                                </template>
                            </v-select>
                        </v-list-item-content>
                    </v-list-item>

                    <template>
                        <v-row>
                            <v-col
                                v-for="(data, i) in data_cta.cta_contents"
                                :key="i"
                                cols="6"
                            >
                                <v-card outlined class="mb-5">
                                    <v-card-text class="pa-2">
                                        <div
                                            class="d-flex"
                                            style="
                                                align-items: center;
                                                gap: 10px;
                                            "
                                        >
                                            <div>
                                                <v-img
                                                    :src="data.content_icon"
                                                    width="39"
                                                    height="39"
                                                />
                                            </div>
                                            <div class="darkgrey--text">
                                                {{ data.content_name }}
                                            </div>
                                            <div
                                                style="
                                                    margin-right: 8px;
                                                    position: absolute;
                                                    right: 0;
                                                "
                                            >
                                                <v-btn
                                                    icon
                                                    @click="
                                                        removeCTAContent(data)
                                                    "
                                                >
                                                    <v-icon color="grey"
                                                        >mdi-close</v-icon
                                                    >
                                                </v-btn>
                                            </div>
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </template>

                    <v-list-item two-line class="pa-0">
                        <v-list-item-content class="pa-0">
                            <v-list-item-title
                                style="font-size: 14px"
                                class="font-weight-500 black60--text"
                            >
                                Deskripsi
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-card-text class="pa-0" style="margin-top: -10px">
                        <app-editor
                            v-on:content-updated="
                                data_cta.cta_description = $event
                            "
                            :value="data_cta.cta_description"
                            :hasUpload="false"
                            :title="'Masukan Deskripsi'"
                        ></app-editor>
                    </v-card-text>
                </template>
            </v-card-text>

            <v-card-actions class="pb-3">
                <v-spacer></v-spacer>
                <v-btn color="darkFade" text @click="$emit('close')">
                    Tutup
                </v-btn>
                <v-btn
                    color="blew"
                    dark
                    depressed
                    :loading="isLoading"
                    @click="content_type === 'cta' ? saveCta() : upload()"
                >
                    Simpan
                </v-btn>
            </v-card-actions>
        </v-card>

        <v-dialog v-model="confirmDialog" persistent max-width="490px">
            <v-card class="py-2">
                <v-card-title style="word-break: break-word !important">
                    Apakah anda akan menghapus interpretasi ini ?
                </v-card-title>
                <v-card-text> interpretasi ini akan dihapus. </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="darkFade" text @click="confirmDialog = false">
                        Batal
                    </v-btn>
                    <v-btn
                        color="red"
                        dark
                        depressed
                        :loading="isLoadingForm"
                        @click="deleteItem()"
                    >
                        Ok
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import AWS from "aws-sdk";
import MarkdownEditor from "@/modules/global/components/plugins/MarkdownEditor-c";
import { applyOssCredentials } from "@/modules/global/services/oss";
import ambis_test from "../services/ambis_test";

export default {
    name: "subinterpretation-form-dialog",
    components: {
        "app-editor": MarkdownEditor,
    },
    data: function () {
        return {
            isLoading: false,
            isLoadingForm: false,
            selectedRow: null,
            confirmDialog: false,
            selectedPicture: null,
            cta_type: "prodi",
            data: {
                title: "",
                description: "",
                icon: "",
                page: 1,
                is_main: false,
            },
            data_cta: {
                interpretation_id: "",
                cta_name: "",
                cta_description: "",
                cta_intro: "",
                cta_code: "",
                cta_contents: [],
            },
            detail: {},
            url: null,
            addNew: false,
            keyimg: 0,
            imageFile: null,
            content_type: "text",
            mapel_konsul: "",
            feature: "",
            mapelList: JSON.parse(localStorage.getItem("mapels")),
            featureList: [
                {
                    id: 1,
                    nama: "Video Pembelajaran",
                    picture:
                        "https://skolla-object.oss-ap-southeast-5.aliyuncs.com/ambis-test/liveclass.svg",
                    url: "",
                },
                {
                    id: 2,
                    nama: "Konsul",
                    picture:
                        "https://skolla-object.oss-ap-southeast-5.aliyuncs.com/ambis-test/ambis-test.svg",
                    url: "",
                },
                {
                    id: 3,
                    nama: "Latihan Soal",
                    picture:
                        "https://skolla-object.oss-ap-southeast-5.aliyuncs.com/ambis-test/tryout.svg",
                    url: "",
                },
            ],
        };
    },

    mounted() {
        if (this.$attrs.detail) {
            this.getDetailSubInterpretation();
        }
    },

    methods: {
        onFileChange(e) {
            const file = e.target.files[0];

            if (file.size > 200000) {
                this.$store.commit("showAlert", {
                    message: `File lebih besar dari 200 KB!`,
                    type: "error",
                });
                return;
            }

            this.imageFile = file;
            this.keyimg++;
            this.url = URL.createObjectURL(file);
        },

        async upload(e = 0) {
            this.isLoading = true;
            const fileImage = this.$refs.uploader.files[0];

            if (this.validateForm()) {
                var file = this.imageFile;
                if (this.data.icon && !file) {
                    this.save();
                } else {
                    if (!file) return;
                    if (file.type.indexOf("image") == -1) return;

                    try {
                        await applyOssCredentials(AWS);
                    } catch (error) {
                        this.$store.commit("showAlert", {
                            message: `Terjadi kesalahan`,
                            submessage: error.message,
                            type: "error",
                        });
                        this.isLoading = false;
                        return;
                    }

                    var spaceEndpoint = process.env.VUE_APP_OSS_END_POINT;
                    var bucket = new AWS.S3({
                        endpoint: spaceEndpoint,
                    });

                    var params = {
                        Bucket: process.env.VUE_APP_OSS_BUCKET,
                        Key:
                            "ambis_test/theme_" +
                            new Date().valueOf() +
                            "_" +
                            file.name,
                        Body: file,
                        ContentType: file.type,
                        ACL: "public-read",
                    };

                    var context = this;
                    bucket.upload(params, function (error, data) {
                        if (error) {
                            context.$store.commit("showAlert", {
                                message: `Terjadi kesalahan`,
                                submessage: error,
                                type: "error",
                            });
                            context.isLoading = false;
                        } else {
                            context.data.icon = data.Location;
                            context.save();
                        }
                    });
                }
            } else {
                this.isLoading = false;
            }
        },

        async save() {
            var context = this;
            const intrepretation_id = context.$attrs.detail.intrepretation_id;
            const subintrepretation_id =
                context.$attrs.detail.sub_interpretation_id;

            context.data.page = context.$attrs.detail.page;

            if (this.validateForm()) {
                context.isLoading = true;

                if (!subintrepretation_id) {
                    ambis_test.addSubInterpretation(
                        intrepretation_id,
                        context.data,
                        function (result) {
                            if (result.success) {
                                context.$store.commit("showAlert", {
                                    message: `Berhasil Menyimpan Data!`,
                                    type: "success",
                                });
                            }
                            context.isLoading = false;
                            context.$emit("save");
                        },
                    );
                } else {
                    ambis_test.editSubInterpretation(
                        subintrepretation_id,
                        context.data,
                        function (result) {
                            if (result.success) {
                                context.$store.commit("showAlert", {
                                    message: `Berhasil Menyimpan Data!`,
                                    type: "success",
                                });
                                context.isLoading = false;
                                context.$emit("save");
                            }
                        },
                    );
                }
            }
        },

        async saveCta() {
            var context = this;
            const intrepretation_id = context.$attrs.detail.intrepretation_id;
            const cta_id = context.$attrs.detail.cta_id;

            context.data_cta.interpretation_id = intrepretation_id;

            if (this.validateFormCta()) {
                context.isLoading = true;

                if (!cta_id) {
                    ambis_test.addCTA(context.data_cta, function (result) {
                        if (result.success) {
                            context.$store.commit("showAlert", {
                                message: `Berhasil Menyimpan Data!`,
                                type: "success",
                            });
                        }
                        context.isLoading = false;
                        context.$emit("save");
                    });
                } else {
                    ambis_test.editCTA(
                        cta_id,
                        context.data_cta,
                        function (result) {
                            if (result.success) {
                                context.$store.commit("showAlert", {
                                    message: `Berhasil Menyimpan Data!`,
                                    type: "success",
                                });
                                context.isLoading = false;
                                context.$emit("save");
                            }
                        },
                    );
                }
            }
        },

        getDetailSubInterpretation() {
            if (this.$attrs.detail.cta_id) {
                this.content_type = "cta";

                this.data_cta = {
                    cta_name: this.$attrs.detail.cta_name,
                    cta_description: this.$attrs.detail.cta_description,
                    cta_intro: this.$attrs.detail.cta_intro,
                    cta_code: this.$attrs.detail.cta_code,
                    cta_contents: this.$attrs.detail.content,
                };
            } else {
                this.content_type = "text";

                this.data = {
                    title: this.$attrs.detail.title,
                    description: this.$attrs.detail.description,
                    icon: this.$attrs.detail.icon,
                    page: this.$attrs.detail.page,
                    is_main: this.$attrs.detail.is_main,
                };
                this.url = this.$attrs.detail.icon;
            }
        },

        handleChangePicture: function (event) {
            const file = event.target.files[0];
            this.selectedPicture = file;
            this.data.picture = URL.createObjectURL(file);
        },

        validateForm() {
            var err = false;
            if (!this.url) {
                this.$store.commit("showAlert", {
                    message: `Gambar tema harus diisi`,
                    type: "error",
                });
                err = true;
            } else if (!this.data.title) {
                this.$store.commit("showAlert", {
                    message: `Title wajib diisi!`,
                    type: "error",
                });
                err = true;
            } else if (!this.data.description) {
                this.$store.commit("showAlert", {
                    message: `Deskripsi wajib diisi!`,
                    type: "error",
                });
                err = true;
            }
            return !err;
        },

        validateFormCta() {
            var err = false;
            if (!this.data_cta.cta_name) {
                this.$store.commit("showAlert", {
                    message: `Jenis CTA wajib diisi!`,
                    type: "error",
                });
                err = true;
            }

            if (!this.data_cta.cta_description) {
                this.$store.commit("showAlert", {
                    message: `Deskripsi CTA wajib diisi!`,
                    type: "error",
                });
                err = true;
            }

            if (
                (this.data_cta.cta_name === "konsul" ||
                    this.data_cta.cta_name === "fitur") &&
                !this.data_cta.cta_contents.length
            ) {
                this.$store.commit("showAlert", {
                    message: `Konten CTA wajib diisi!`,
                    type: "error",
                });
                err = true;
            }
            return !err;
        },

        addCTAContent(data, type) {
            const checkCTAContent = this.data_cta.cta_contents.find(
                (e) => e.content_code === data.id,
            );

            if (!checkCTAContent) {
                var url =
                    type === "konsul"
                        ? `/konsultasi?mapel_id=${data.id}`
                        : this.data_cta.cta_name;

                this.data_cta.cta_contents.push({
                    content_code: data.id,
                    cta_content_id: "",
                    content_name: data.nama,
                    content_icon: data.picture,
                    content_url: url,
                });
            }

            setTimeout(() => {
                this.mapel_konsul = "null";
                this.feature = "null";
            }, 500);
        },

        removeCTAContent(row) {
            const arrayContent = this.data_cta.cta_contents;

            this.data_cta.cta_contents = arrayContent.filter(
                (obj) => obj.content_code !== row.content_code,
            );
        },

        confirmDeleteItem(val) {
            this.selectedRow = val;
            this.confirmDialog = true;
        },

        deleteItem() {
            var context = this;
            const id =
                context.$attrs.detail.sub_interpretation_id ||
                context.$attrs.detail.cta_id;

            context.isLoadingForm = true;

            if (context.content_type === "text") {
                ambis_test.deleteSubInterpretation(id, function (result) {
                    if (result.success) {
                        context.isLoadingForm = false;
                        context.$emit("save");
                    } else {
                        context.isLoadingForm = false;
                        context.$store.commit("showAlert", {
                            message: `Gagal Menghapus Data!`,
                            type: "error",
                        });
                    }
                });
            } else {
                ambis_test.deleteCTA(id, function (result) {
                    if (result.success) {
                        context.isLoadingForm = false;
                        context.$emit("save");
                    } else {
                        context.isLoadingForm = false;
                        context.$store.commit("showAlert", {
                            message: `Gagal Menghapus Data!`,
                            type: "error",
                        });
                    }
                });
            }
        },
    },
};
</script>

<style>
.radio-selection {
    background: #fbfbfb;
    border: 1px solid #ebebeb;
    box-sizing: border-box;
    border-radius: 100px;
}
</style>



// WEBPACK FOOTER //
// DialogSubInterpretasi.vue?2ce02c54